import styled from 'styled-components';

import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';

export const CardIframe = styled.div`
  border-radius: 4px;
  overflow: hidden;
  pointer-events: none;
  position: relative;
  transform-origin: center;
  width: calc(1440px * 0.36);
  height: calc(1080px * 0.36);
`;
CardIframe.displayName = 'CardIframe';

export const Frame = styled.iframe`
  width: 1440px;
  height: 1080px;
  border: none;
  position: absolute;
  top: 0;
  left: 0;
  transform: scale(0.36);
  transform-origin: 0 0;
`;
Frame.displayName = 'Frame';

export const CardStyled = styled(Card)`
  background-color: #d2fa00;
`;
CardStyled.displayName = 'CardStyled';

export const CardActionAreaStyled = styled(CardActionArea)`
  align-items: stretch;
  display: flex;
  CardIframe @media only screen and (max-width: 540px) {
    flex-direction: column;
  }
`;
CardActionAreaStyled.displayName = 'CardActionAreaStyled';

export const CardContentStyled = styled(CardContent)`
  color: #000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 32px;

  @media only screen and (max-width: 540px) {
    padding: 16px;
  }
`;
CardContentStyled.displayName = 'CardContentStyled';

export const DescriptionWrapper = styled.div`
  color: #000;
  display: flex;
  flex-direction: column;
  font-weight: 400;
  gap: 8px;
  margin-top: 32px;

  @media only screen and (max-width: 540px) {
    display: none;
  }
`;
DescriptionWrapper.displayName = 'DescriptionWrapper';

export const ImageBackgroundStyled = styled.div`
  align-items: center;
  background: rgba(6, 6, 6, 0.25);
  display: flex;
  padding: 16px;
`;
ImageBackgroundStyled.displayName = 'ImageBackgroundStyled';
